import { FC, useContext } from 'react'
import { Container, Row, Col } from '@mch-group/uikit-components'
import { Text } from '@components'
import { LoginContext } from '@providers/Login'

interface IPressAccIntro {
  id: string
  mpai_login_description: string
  mpai_logout_description: string
}

const PressAccreditationIntro: FC<IPressAccIntro> = ({
  id,
  mpai_login_description,
  mpai_logout_description
}) => {
  const { user } = useContext(LoginContext)

  return (
    <Container id={id} className='px-5 px-lg-8 px-md-7 pb-5 pb-md-7 pb-xl-8 pt-0 mt-9'>
      <Row>
        <Col xs={12} md={12} xl={6}>
          <Text forwardedAs='div' isHtml className='text-medium'>
            {(user?.me ? mpai_login_description : mpai_logout_description) || ''}
          </Text>
        </Col>
      </Row>
    </Container>
  )
}

export default PressAccreditationIntro
